import { useState } from "react";
import { MAX_PRISE } from "../../datas/constantsValues";
import SearchContext from "../context/searchContext";

const SearchProvider = ({ children }) => {
  //state variables
  const [keyword, setKeyword] = useState("");
  const [filters, setFilters] = useState([]);
  const [priceRange, setPriceRange] = useState(MAX_PRISE);
  const [showMobileSearchInput, setShowMobileSearchInput] = useState(false);

  /**
   * Update the current search keyword
   * @param {string} key
   */
  const addKeyword = (key) => {
    setFilters([]);

    setKeyword(key);
  };

  /**
   * add some filters to the current filters
   * @param {Array} filtersTags
   */
  const addFilters = (filtersTags) => {
    setKeyword("");

    if (!Array.isArray(filtersTags)) {
      const setOfFilters = new Set([...filters, filtersTags]);
      return setFilters([...setOfFilters]);
    }

    const setOfFilter = new Set([...filters, ...filtersTags]);
    setFilters([...setOfFilter]);
  };

  /**
   * Remove some filters to the current filters
   * @param {Array} filtersTags
   */
  const removeFilters = (filtersTags) => {
    setKeyword("");

    const newFilters = new Set([...filters]);

    if (!Array.isArray(filtersTags))
      return setFilters(filters.filter((filter) => filter !== filtersTags));

    const setOfFilters = new Set([...filters]);
    filtersTags.forEach((tag) => setOfFilters.delete(tag));
    setFilters([...setOfFilters]);
  };

  const resetAllSearch = () => {
    setKeyword("");
    setFilters([]);
    setPriceRange(MAX_PRISE);
  };

  //context value
  const contextValue = {
    keyword,
    filters,
    priceRange,
    showMobileSearchInput,
    addKeyword,
    addFilters,
    removeFilters,
    setFilters,
    setPriceRange,
    setShowMobileSearchInput,
    resetAllSearch,
  };

  return (
    <SearchContext.Provider value={contextValue}>
      {children}
    </SearchContext.Provider>
  );
};

export default SearchProvider;
